import { useGetUserQuery } from '~/types/types';
export function isImpactEditable(impact) {
  return (impact === null || impact === void 0 ? void 0 : impact.isEditable) !== false;
}
export function isImpactLocked(impact) {
  return (impact === null || impact === void 0 ? void 0 : impact.isEditable) === false;
}

/** Venture/portfolio editors respect freeze; IX staff may edit while lock UI stays visible. */
export function canEditImpact(impact, realUserIsIxAdmin) {
  return realUserIsIxAdmin || isImpactEditable(impact);
}
export function useRealUserIsIxAdmin() {
  var _useGetUserQuery = useGetUserQuery(),
    result = _useGetUserQuery.result;
  return computed(function () {
    var _result$value, _result$value$getUser;
    return Boolean((_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getUser = _result$value.getUser) === null || _result$value$getUser === void 0 ? void 0 : _result$value$getUser.realUserIsAdmin);
  });
}